export const privacyPolicies = {
  "Políticas de privacidade": "Políticas de privacidade"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/privacyPolicies.js